module.exports = __webpack_public_path__ + "img/arrows-fullscreen.d9ddd3b3.svg";